module.exports = __webpack_public_path__ + "img/PPT版_00.3e0d52a7.png";